export default __webpack_public_path__ + "static/media/calendar1.0344f2d9.svg";